import * as types from '../mutation-types';
import axios from 'axios';

export const state = () => ({
    toogleModal: false,
    modalType: false,
    modalId: 0,
    modalCloseButton: false,
    modalContent: {},
    wishlistModalContent: {},
    watchdogModalContent: {},
    wishlistIcon: 0,
    previousModalName: '',
    previousModalId: '',
    modalCookies: false,
});

export const getters = {
    toogleModal: state => state.toogleModal,
    modalType: state => state.modalType,
    modalId: state => state.modalId,
    modalCloseButton: state => state.modalCloseButton,
    modalContent: state => state.modalContent,
    wishlistModalContent: state => state.wishlistModalContent,
    watchdogModalContent: state => state.watchdogModalContent,
    wishlistIcon: state => state.wishlistIcon,
    previousModalName: state => state.previousModalName,
    previousModalId: state => state.previousModalId,
    modalCookies: state => state.modalCookies,
};

export const mutations = {
    [types.SET_TOOGLE_MODAL](state, toogleModal) {
        state.toogleModal = toogleModal;
    },
    [types.SET_MODAL_TYPE](state, modalType) {
        state.modalType = modalType;
    },
    [types.SET_MODAL_ID](state, modalId) {
        state.modalId = modalId;
    },
    [types.SET_MODAL_CLOSE_BUTTON](state, modalCloseButton) {
        state.modalCloseButton = modalCloseButton;
    },
    [types.SET_MODAL_CONTENT](state, modalContent) {
        state.modalContent = modalContent;
    },
    [types.SET_WISHLIST_MODAL_CONTENT](state, wishlistModalContent) {
        state.wishlistModalContent = wishlistModalContent;
    },
    [types.SET_WATCHDOG_MODAL_CONTENT](state, watchdogModalContent) {
        state.watchdogModalContent = watchdogModalContent;
    },
    [types.SET_WISHLIST_ICON](state, wishlistIcon) {
        state.wishlistIcon = wishlistIcon;
    },
    [types.SET_PREVIOUS_MODAL_NAME](state, previousModalName) {
        state.previousModalName = previousModalName;
    },
    [types.SET_PREVIOUS_MODAL_ID](state, previousModalId) {
        state.previousModalId = previousModalId;
    },
    [types.SET_MODAL_COOKIE](state, modalCookies) {
        state.modalCookies = modalCookies;
    },
};

export const actions = {
    async fetchModalContent({ commit, rootGetters, getters }, { modalType, modalId }) {
        const response = await axios.get('/modal-content/' + modalType + '/' + modalId);

        commit('SET_MODAL_CONTENT', response.data);

        return response;
    },

    async fetchWishlistModalContent({ commit, rootGetters, getters }, { modalId }) {
        const response = await axios.get('/wishlist-get/' + modalId);

        commit('SET_WISHLIST_MODAL_CONTENT', response.data);

        return response;
    },

    async fetchWatchdogModalContent({ commit, rootGetters, getters, rootState }, { modalId }) {
        var response;
        if (rootState.auth.user) {
            response = await axios.get('/watchdog-get-auth/' + modalId);
        } else {
            response = await axios.get('/watchdog-get/' + modalId);
        }

        commit('SET_WATCHDOG_MODAL_CONTENT', response.data);

        return response;
    },
};
